import { applyMiddleware, createStore, compose } from 'redux'

import { rootReducer } from '../src/app/store/reducers/index/index'
import ErrorHandler from './middlewares/ErrorHandler'
import { configureStore } from '@reduxjs/toolkit'
import { globalErrorMiddleware } from './middlewares/globalError'
import { baseApi } from '@shared/api'

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose
  }
}
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

// const store = createStore(
//   rootReducer,
//   composeEnhancers
//   (applyMiddleware(...middlewares)
//   ))

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat([ErrorHandler, globalErrorMiddleware, baseApi.middleware])
})

export type AppDispatch = typeof store.dispatch
export default store
